const baseEndpoint = '/iphone';

export const paths = {
  apps: `${baseEndpoint}/apps`,
  clientPolicy: `${baseEndpoint}/client_policy`,
  email: `${baseEndpoint}/notification/email`,
  emailActivation: `${baseEndpoint}/notification/email/activate`,
};
